import React from "react";
import PropTypes from "prop-types";
import "./Panel.scss";

/**
 * SectionTitle — the standard heading above a panel or block.
 *
 * Was copy-pasted into three Engagement files with three slightly different
 * margins, which is exactly the drift a shared component prevents: same
 * typography everywhere, spacing chosen from a named option rather than by
 * whoever edited last.
 */
export const SectionTitle = ({ children, spacing = "default", className = "" }) => (
  <h3 className={`section-title section-title--${spacing} ${className}`}>
    {children}
  </h3>
);

SectionTitle.propTypes = {
  children: PropTypes.node,
  /** default = space above; tight = little; flush = none (first in a column) */
  spacing: PropTypes.oneOf(["default", "tight", "flush"]),
  className: PropTypes.string,
};

/**
 * Panel — a titled white card. The container that most analytics blocks sit in.
 */
export const Panel = ({
  title,
  subtitle,
  actions,
  children,
  spacing = "default",
  className = "",
  style,
}) => (
  <div className={className} style={style}>
    {(title || actions) && (
      <div className={actions || subtitle ? `panel__head${subtitle ? "" : " panel__head--plain"}` : undefined}>
        <div>
          {title && <SectionTitle spacing={subtitle ? "flush" : spacing}>{title}</SectionTitle>}
          {subtitle && <p className="panel__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="panel__actions">{actions}</div>}
      </div>
    )}
    <div className="panel">{children}</div>
  </div>
);

Panel.propTypes = {
  title: PropTypes.node,
  /** One line under the title: the question the panel answers, or how to read it. */
  subtitle: PropTypes.node,
  /** Controls aligned right of the title. */
  actions: PropTypes.node,
  children: PropTypes.node,
  spacing: PropTypes.oneOf(["default", "tight", "flush"]),
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Panel;
